module.exports = __webpack_public_path__ + "img/02.59af63a7.jpg";